import React from 'react';
import DashboardLayout from '../components/dashboard/DashboardLayout';


const Dashboard = () => {



  return (
    <div className="container-fluid  " >
      <DashboardLayout   />
    </div>
  );
};

export default Dashboard;

